import { useState } from "react";
import NavBar from "../NavBar";
import { SideBar } from "../SideBar";

interface Props {
  children: any;
  isLoading?: boolean;
}

export const PageLayout = ({ children, isLoading }: Props) => {
  const [nav, setNav] = useState<boolean>(false);
  const [navbar, setNavbar] = useState<boolean>(false);
  return (
    <div className=" w-full bg-[#FAFAFA] relative">
      <div className="fixed  top-0 z-[1000] w-full">
        <NavBar
          hasSet={(e: any) => setNav(e)}
          navbar={navbar}
          setNavbar={setNavbar}
        />
      </div>
        <div >
          <div className="px-0 w-full mt-20">{children}</div>
        </div>
        <div>
          <SideBar
            open={nav}
            hasSet={(e: any) => setNav(e)}
            navbar={navbar}
            setNavbar={setNavbar}
            setOpen={setNav}
          />
        </div>
    </div>
  );
};